import React, { MouseEventHandler } from "react"
import styled from "styled-components"
import { colors } from "../../styles"
import { scale } from "../../styles/utils/calc"
import { Icon } from "../Icon"

export interface FavouriteButtonProps {
	filled?: boolean
	onClick: MouseEventHandler<HTMLButtonElement>
}

const StyledFavouriteButton = styled.button`
	align-items: center;
	justify-content: center;
	padding: ${scale.px(0.5)};
	background: rgba(256, 256, 256, 0.6);
	border-radius: ${scale.px(3)};
	border: 1px solid transparent;
	&:hover {
		border: 1px solid ${colors.hoverBlue};
	}
`

const FavouriteButton: React.FC<FavouriteButtonProps> = ({
	filled,
	onClick,
}) => (
	<StyledFavouriteButton onClick={onClick}>
		<Icon color={"navy"} icon={filled ? "heart-filled" : "heart"} />
	</StyledFavouriteButton>
)

export { FavouriteButton }
